import { render, staticRenderFns } from "./PathwayFooter.vue?vue&type=template&id=06364a32"
import script from "./PathwayFooter.vue?vue&type=script&lang=js"
export * from "./PathwayFooter.vue?vue&type=script&lang=js"
import style0 from "./PathwayFooter.vue?vue&type=style&index=0&id=06364a32&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports